import * as React from 'react';
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline';
import PoppinsFontRegular from '@pixel/assets/fonts/Poppins/Poppins-Regular.ttf';
import PoppinsFontMedium from '@pixel/assets/fonts/Poppins/Poppins-Medium.ttf';
import PoppinsFontSemiBold from '@pixel/assets/fonts/Poppins/Poppins-SemiBold.ttf';
import SourceSansProFontRegular from '@pixel/assets/fonts/SourceSansPro/SourceSansPro-Regular.ttf';
import SourceSansProFontSemiBold from '@pixel/assets/fonts/SourceSansPro/SourceSansPro-SemiBold.ttf';
const addStyleFontFacesToHead = async () => {
  let font = null;
  font = new FontFace("Poppins", "url(".concat(PoppinsFontRegular, ")"), {
    style: "normal",
    weight: "normal"
  });
  await font.load();
  document.fonts.add(font);
  font = new FontFace("Poppins", "url(".concat(PoppinsFontMedium, ")"), {
    style: "normal",
    weight: "500"
  });
  await font.load();
  document.fonts.add(font);
  font = new FontFace("Poppins", "url(".concat(PoppinsFontSemiBold, ")"), {
    style: "normal",
    weight: "600"
  });
  await font.load();
  document.fonts.add(font);
  font = new FontFace("Source Sans Pro", "url(".concat(SourceSansProFontRegular, ")"), {
    style: "normal",
    weight: "normal"
  });
  await font.load();
  document.fonts.add(font);
  font = new FontFace("Source Sans Pro", "url(".concat(SourceSansProFontSemiBold, ")"), {
    style: "normal",
    weight: "600"
  });
  await font.load();
  document.fonts.add(font);
  //console.log('Pixel Font faces loaded", "NOTE: If you are seeing network failed requests you may need to add ttf and woff and woff2 files to webpack file output rules. Or configure your CSP');
};
const BaseFontCss = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    omitBaselineCss,
    cssPrefix = ""
  } = _ref;
  React.useEffect(() => {
    addStyleFontFacesToHead();
  }, []);

  //add border-box to all elements inside the div
  React.useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = ".BaseFontCss * { box-sizing: border-box; }";
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, omitBaselineCss ? children : /*#__PURE__*/React.createElement(ScopedCssBaseline, {
    "data-qa": "BaseFontCss",
    className: "BaseFontCss",
    ref: ref,
    sx: {
      display: 'flex',
      flex: 1,
      minWidth: 10
    }
  }, children));
});
export default BaseFontCss;